import { render, staticRenderFns } from "./TemplateDataStep.vue?vue&type=template&id=7774b9fb"
import script from "./TemplateDataStep.vue?vue&type=script&lang=js"
export * from "./TemplateDataStep.vue?vue&type=script&lang=js"
import style0 from "./TemplateDataStep.vue?vue&type=style&index=0&id=7774b9fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports